// source: client/frontend/web/component_ae_answer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb =
    require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var imports_answer_solution_format_pb =
    require('../../../imports/answer/solution_format_pb.js');
goog.object.extend(proto, imports_answer_solution_format_pb);
var imports_answer_solution_source_pb =
    require('../../../imports/answer/solution_source_pb.js');
goog.object.extend(proto, imports_answer_solution_source_pb);
var imports_answer_solution_type_pb =
    require('../../../imports/answer/solution_type_pb.js');
goog.object.extend(proto, imports_answer_solution_type_pb);
var imports_content_component_type_pb =
    require('../../../imports/content/component_type_pb.js');
goog.object.extend(proto, imports_content_component_type_pb);
var imports_content_question_status_pb =
    require('../../../imports/content/question_status_pb.js');
goog.object.extend(proto, imports_content_question_status_pb);
var imports_options_event_metadata_pb =
    require('../../../imports/options/event_metadata_pb.js');
goog.object.extend(proto, imports_options_event_metadata_pb);
goog.exportSymbol('proto.com.chegg.rio.qna.ComponentAEAnswer', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.chegg.rio.qna.ComponentAEAnswer = function(opt_data) {
  jspb.Message.initialize(
      this, opt_data, 0, 500,
      proto.com.chegg.rio.qna.ComponentAEAnswer.repeatedFields_, null);
};
goog.inherits(proto.com.chegg.rio.qna.ComponentAEAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.chegg.rio.qna.ComponentAEAnswer.displayName =
      'proto.com.chegg.rio.qna.ComponentAEAnswer';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.repeatedFields_ = [240, 621];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.toObject = function(
      opt_includeInstance) {
    return proto.com.chegg.rio.qna.ComponentAEAnswer.toObject(
        opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.chegg.rio.qna.ComponentAEAnswer} msg The msg instance to
   *     transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.chegg.rio.qna.ComponentAEAnswer.toObject = function(
      includeInstance, msg) {
    var f, obj = {
      componentType: jspb.Message.getFieldWithDefault(msg, 217, 0),
      componentName: jspb.Message.getFieldWithDefault(msg, 218, ''),
      questionUuid: jspb.Message.getFieldWithDefault(msg, 219, ''),
      questionPublishedDate: (f = msg.getQuestionPublishedDate()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      hasAnswerPreview:
          jspb.Message.getBooleanFieldWithDefault(msg, 223, false),
      hasTranscribedText:
          jspb.Message.getBooleanFieldWithDefault(msg, 224, false),
      isEnhancedContent:
          jspb.Message.getBooleanFieldWithDefault(msg, 225, false),
      questionStatus: jspb.Message.getFieldWithDefault(msg, 226, 0),
      positiveRatings: jspb.Message.getFieldWithDefault(msg, 233, 0),
      negativeRatings: jspb.Message.getFieldWithDefault(msg, 234, 0),
      totalRatings: jspb.Message.getFieldWithDefault(msg, 235, 0),
      isFlaggedByUser: jspb.Message.getBooleanFieldWithDefault(msg, 239, false),
      solutionIdsList:
          (f = jspb.Message.getRepeatedField(msg, 240)) == null ? undefined : f,
      hasVideo: jspb.Message.getBooleanFieldWithDefault(msg, 254, false),
      hasImage: jspb.Message.getBooleanFieldWithDefault(msg, 255, false),
      previewHasVideo: jspb.Message.getBooleanFieldWithDefault(msg, 256, false),
      markupCharacterCountInAnswer:
          jspb.Message.getFieldWithDefault(msg, 274, 0),
      numberOfComments: jspb.Message.getFieldWithDefault(msg, 276, 0),
      questionId: jspb.Message.getFieldWithDefault(msg, 281, 0),
      isAnswerToOwnQuestion:
          jspb.Message.getBooleanFieldWithDefault(msg, 282, false),
      isBookmarkedByUser:
          jspb.Message.getBooleanFieldWithDefault(msg, 604, false),
      stepsInAnswer: jspb.Message.getFieldWithDefault(msg, 605, 0),
      currentStep: jspb.Message.getFieldWithDefault(msg, 607, 0),
      stepsInPreview: jspb.Message.getFieldWithDefault(msg, 608, 0),
      blocksInPreview: jspb.Message.getFieldWithDefault(msg, 609, 0),
      previewHasImage: jspb.Message.getBooleanFieldWithDefault(msg, 610, false),
      previewHasDrawing:
          jspb.Message.getBooleanFieldWithDefault(msg, 612, false),
      previewHasEquation:
          jspb.Message.getBooleanFieldWithDefault(msg, 613, false),
      previewHasTable: jspb.Message.getBooleanFieldWithDefault(msg, 614, false),
      characterCountInPreview: jspb.Message.getFieldWithDefault(msg, 615, 0),
      solutionPublishedTime: (f = msg.getSolutionPublishedTime()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      solutionLanguage: jspb.Message.getFieldWithDefault(msg, 617, ''),
      solutionType: jspb.Message.getFieldWithDefault(msg, 618, 0),
      solutionFormat: jspb.Message.getFieldWithDefault(msg, 619, 0),
      solutionSource: jspb.Message.getFieldWithDefault(msg, 620, 0),
      solutionUuidList:
          (f = jspb.Message.getRepeatedField(msg, 621)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.chegg.rio.qna.ComponentAEAnswer;
  return proto.com.chegg.rio.qna.ComponentAEAnswer.deserializeBinaryFromReader(
      msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.chegg.rio.qna.ComponentAEAnswer} msg The message object to
 *     deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.deserializeBinaryFromReader =
    function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 217:
        var value =
            /** @type {!proto.com.chegg.rio.content.component.ComponentType} */
            (reader.readEnum());
        msg.setComponentType(value);
        break;
      case 218:
        var value = /** @type {string} */ (reader.readString());
        msg.setComponentName(value);
        break;
      case 219:
        var value = /** @type {string} */ (reader.readString());
        msg.setQuestionUuid(value);
        break;
      case 222:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setQuestionPublishedDate(value);
        break;
      case 223:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setHasAnswerPreview(value);
        break;
      case 224:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setHasTranscribedText(value);
        break;
      case 225:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsEnhancedContent(value);
        break;
      case 226:
        var value = /** @type {!proto.com.chegg.rio.content.QuestionStatus} */ (
            reader.readEnum());
        msg.setQuestionStatus(value);
        break;
      case 233:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setPositiveRatings(value);
        break;
      case 234:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setNegativeRatings(value);
        break;
      case 235:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setTotalRatings(value);
        break;
      case 239:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsFlaggedByUser(value);
        break;
      case 240:
        var values = /** @type {!Array<number>} */ (
            reader.isDelimited() ? reader.readPackedInt64() :
                                   [reader.readInt64()]);
        for (var i = 0; i < values.length; i++) {
          msg.addSolutionIds(values[i]);
        }
        break;
      case 254:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setHasVideo(value);
        break;
      case 255:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setHasImage(value);
        break;
      case 256:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setPreviewHasVideo(value);
        break;
      case 274:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setMarkupCharacterCountInAnswer(value);
        break;
      case 276:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setNumberOfComments(value);
        break;
      case 281:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setQuestionId(value);
        break;
      case 282:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsAnswerToOwnQuestion(value);
        break;
      case 604:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsBookmarkedByUser(value);
        break;
      case 605:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setStepsInAnswer(value);
        break;
      case 607:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setCurrentStep(value);
        break;
      case 608:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setStepsInPreview(value);
        break;
      case 609:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setBlocksInPreview(value);
        break;
      case 610:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setPreviewHasImage(value);
        break;
      case 612:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setPreviewHasDrawing(value);
        break;
      case 613:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setPreviewHasEquation(value);
        break;
      case 614:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setPreviewHasTable(value);
        break;
      case 615:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setCharacterCountInPreview(value);
        break;
      case 616:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setSolutionPublishedTime(value);
        break;
      case 617:
        var value = /** @type {string} */ (reader.readString());
        msg.setSolutionLanguage(value);
        break;
      case 618:
        var value = /** @type {!proto.com.chegg.rio.qna.SolutionType} */ (
            reader.readEnum());
        msg.setSolutionType(value);
        break;
      case 619:
        var value = /** @type {!proto.com.chegg.rio.qna.SolutionFormat} */ (
            reader.readEnum());
        msg.setSolutionFormat(value);
        break;
      case 620:
        var value = /** @type {!proto.com.chegg.rio.qna.SolutionSource} */ (
            reader.readEnum());
        msg.setSolutionSource(value);
        break;
      case 621:
        var value = /** @type {string} */ (reader.readString());
        msg.addSolutionUuid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.serializeBinary =
    function() {
  var writer = new jspb.BinaryWriter();
  proto.com.chegg.rio.qna.ComponentAEAnswer.serializeBinaryToWriter(
      this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.chegg.rio.qna.ComponentAEAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.serializeBinaryToWriter = function(
    message, writer) {
  var f = undefined;
  f = message.getComponentType();
  if (f !== 0.0) {
    writer.writeEnum(217, f);
  }
  f = message.getComponentName();
  if (f.length > 0) {
    writer.writeString(218, f);
  }
  f = message.getQuestionUuid();
  if (f.length > 0) {
    writer.writeString(219, f);
  }
  f = message.getQuestionPublishedDate();
  if (f != null) {
    writer.writeMessage(
        222, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 223));
  if (f != null) {
    writer.writeBool(223, f);
  }
  f = message.getHasTranscribedText();
  if (f) {
    writer.writeBool(224, f);
  }
  f = message.getIsEnhancedContent();
  if (f) {
    writer.writeBool(225, f);
  }
  f = message.getQuestionStatus();
  if (f !== 0.0) {
    writer.writeEnum(226, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 233));
  if (f != null) {
    writer.writeInt64(233, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 234));
  if (f != null) {
    writer.writeInt64(234, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 235));
  if (f != null) {
    writer.writeInt64(235, f);
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 239));
  if (f != null) {
    writer.writeBool(239, f);
  }
  f = message.getSolutionIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(240, f);
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 254));
  if (f != null) {
    writer.writeBool(254, f);
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 255));
  if (f != null) {
    writer.writeBool(255, f);
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 256));
  if (f != null) {
    writer.writeBool(256, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 274));
  if (f != null) {
    writer.writeInt64(274, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 276));
  if (f != null) {
    writer.writeInt64(276, f);
  }
  f = message.getQuestionId();
  if (f !== 0) {
    writer.writeInt64(281, f);
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 282));
  if (f != null) {
    writer.writeBool(282, f);
  }
  f = message.getIsBookmarkedByUser();
  if (f) {
    writer.writeBool(604, f);
  }
  f = message.getStepsInAnswer();
  if (f !== 0) {
    writer.writeInt64(605, f);
  }
  f = message.getCurrentStep();
  if (f !== 0) {
    writer.writeInt64(607, f);
  }
  f = message.getStepsInPreview();
  if (f !== 0) {
    writer.writeInt64(608, f);
  }
  f = message.getBlocksInPreview();
  if (f !== 0) {
    writer.writeInt64(609, f);
  }
  f = message.getPreviewHasImage();
  if (f) {
    writer.writeBool(610, f);
  }
  f = message.getPreviewHasDrawing();
  if (f) {
    writer.writeBool(612, f);
  }
  f = message.getPreviewHasEquation();
  if (f) {
    writer.writeBool(613, f);
  }
  f = message.getPreviewHasTable();
  if (f) {
    writer.writeBool(614, f);
  }
  f = message.getCharacterCountInPreview();
  if (f !== 0) {
    writer.writeInt64(615, f);
  }
  f = message.getSolutionPublishedTime();
  if (f != null) {
    writer.writeMessage(
        616, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = message.getSolutionLanguage();
  if (f.length > 0) {
    writer.writeString(617, f);
  }
  f = message.getSolutionType();
  if (f !== 0.0) {
    writer.writeEnum(618, f);
  }
  f = message.getSolutionFormat();
  if (f !== 0.0) {
    writer.writeEnum(619, f);
  }
  f = message.getSolutionSource();
  if (f !== 0.0) {
    writer.writeEnum(620, f);
  }
  f = message.getSolutionUuidList();
  if (f.length > 0) {
    writer.writeRepeatedString(621, f);
  }
};


/**
 * optional com.chegg.rio.content.component.ComponentType component_type = 217;
 * @return {!proto.com.chegg.rio.content.component.ComponentType}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getComponentType =
    function() {
  return /** @type {!proto.com.chegg.rio.content.component.ComponentType} */ (
      jspb.Message.getFieldWithDefault(this, 217, 0));
};


/**
 * @param {!proto.com.chegg.rio.content.component.ComponentType} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setComponentType = function(
    value) {
  return jspb.Message.setProto3EnumField(this, 217, value);
};


/**
 * optional string component_name = 218;
 * @return {string}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getComponentName =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 218, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setComponentName = function(
    value) {
  return jspb.Message.setProto3StringField(this, 218, value);
};


/**
 * optional string question_uuid = 219;
 * @return {string}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getQuestionUuid =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 219, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setQuestionUuid = function(
    value) {
  return jspb.Message.setProto3StringField(this, 219, value);
};


/**
 * optional google.protobuf.Timestamp question_published_date = 222;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getQuestionPublishedDate =
    function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 222));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setQuestionPublishedDate =
    function(value) {
  return jspb.Message.setWrapperField(this, 222, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearQuestionPublishedDate =
    function() {
  return this.setQuestionPublishedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasQuestionPublishedDate =
    function() {
  return jspb.Message.getField(this, 222) != null;
};


/**
 * optional bool has_answer_preview = 223;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getHasAnswerPreview =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 223, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setHasAnswerPreview =
    function(value) {
  return jspb.Message.setField(this, 223, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearHasAnswerPreview =
    function() {
  return jspb.Message.setField(this, 223, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasHasAnswerPreview =
    function() {
  return jspb.Message.getField(this, 223) != null;
};


/**
 * optional bool has_transcribed_text = 224;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getHasTranscribedText =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 224, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setHasTranscribedText =
    function(value) {
  return jspb.Message.setProto3BooleanField(this, 224, value);
};


/**
 * optional bool is_enhanced_content = 225;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getIsEnhancedContent =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 225, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setIsEnhancedContent =
    function(value) {
  return jspb.Message.setProto3BooleanField(this, 225, value);
};


/**
 * optional com.chegg.rio.content.QuestionStatus question_status = 226;
 * @return {!proto.com.chegg.rio.content.QuestionStatus}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getQuestionStatus =
    function() {
  return /** @type {!proto.com.chegg.rio.content.QuestionStatus} */ (
      jspb.Message.getFieldWithDefault(this, 226, 0));
};


/**
 * @param {!proto.com.chegg.rio.content.QuestionStatus} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setQuestionStatus =
    function(value) {
  return jspb.Message.setProto3EnumField(this, 226, value);
};


/**
 * optional int64 positive_ratings = 233;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getPositiveRatings =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 233, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setPositiveRatings =
    function(value) {
  return jspb.Message.setField(this, 233, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearPositiveRatings =
    function() {
  return jspb.Message.setField(this, 233, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasPositiveRatings =
    function() {
  return jspb.Message.getField(this, 233) != null;
};


/**
 * optional int64 negative_ratings = 234;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getNegativeRatings =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 234, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setNegativeRatings =
    function(value) {
  return jspb.Message.setField(this, 234, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearNegativeRatings =
    function() {
  return jspb.Message.setField(this, 234, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasNegativeRatings =
    function() {
  return jspb.Message.getField(this, 234) != null;
};


/**
 * optional int64 total_ratings = 235;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getTotalRatings =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 235, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setTotalRatings = function(
    value) {
  return jspb.Message.setField(this, 235, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearTotalRatings =
    function() {
  return jspb.Message.setField(this, 235, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasTotalRatings =
    function() {
  return jspb.Message.getField(this, 235) != null;
};


/**
 * optional bool is_flagged_by_user = 239;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getIsFlaggedByUser =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 239, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setIsFlaggedByUser =
    function(value) {
  return jspb.Message.setField(this, 239, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearIsFlaggedByUser =
    function() {
  return jspb.Message.setField(this, 239, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasIsFlaggedByUser =
    function() {
  return jspb.Message.getField(this, 239) != null;
};


/**
 * repeated int64 solution_ids = 240;
 * @return {!Array<number>}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getSolutionIdsList =
    function() {
  return /** @type {!Array<number>} */ (
      jspb.Message.getRepeatedField(this, 240));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setSolutionIdsList =
    function(value) {
  return jspb.Message.setField(this, 240, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.addSolutionIds = function(
    value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 240, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearSolutionIdsList =
    function() {
  return this.setSolutionIdsList([]);
};


/**
 * optional bool has_video = 254;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getHasVideo = function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 254, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setHasVideo = function(
    value) {
  return jspb.Message.setField(this, 254, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearHasVideo = function() {
  return jspb.Message.setField(this, 254, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasHasVideo = function() {
  return jspb.Message.getField(this, 254) != null;
};


/**
 * optional bool has_image = 255;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getHasImage = function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 255, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setHasImage = function(
    value) {
  return jspb.Message.setField(this, 255, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearHasImage = function() {
  return jspb.Message.setField(this, 255, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasHasImage = function() {
  return jspb.Message.getField(this, 255) != null;
};


/**
 * optional bool preview_has_video = 256;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getPreviewHasVideo =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 256, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setPreviewHasVideo =
    function(value) {
  return jspb.Message.setField(this, 256, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearPreviewHasVideo =
    function() {
  return jspb.Message.setField(this, 256, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasPreviewHasVideo =
    function() {
  return jspb.Message.getField(this, 256) != null;
};


/**
 * optional int64 markup_character_count_in_answer = 274;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype
    .getMarkupCharacterCountInAnswer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 274, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype
    .setMarkupCharacterCountInAnswer = function(value) {
  return jspb.Message.setField(this, 274, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype
    .clearMarkupCharacterCountInAnswer = function() {
  return jspb.Message.setField(this, 274, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype
    .hasMarkupCharacterCountInAnswer = function() {
  return jspb.Message.getField(this, 274) != null;
};


/**
 * optional int64 number_of_comments = 276;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getNumberOfComments =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 276, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setNumberOfComments =
    function(value) {
  return jspb.Message.setField(this, 276, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearNumberOfComments =
    function() {
  return jspb.Message.setField(this, 276, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasNumberOfComments =
    function() {
  return jspb.Message.getField(this, 276) != null;
};


/**
 * optional int64 question_id = 281;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getQuestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 281, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setQuestionId = function(
    value) {
  return jspb.Message.setProto3IntField(this, 281, value);
};


/**
 * optional bool is_answer_to_own_question = 282;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getIsAnswerToOwnQuestion =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 282, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setIsAnswerToOwnQuestion =
    function(value) {
  return jspb.Message.setField(this, 282, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearIsAnswerToOwnQuestion =
    function() {
  return jspb.Message.setField(this, 282, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasIsAnswerToOwnQuestion =
    function() {
  return jspb.Message.getField(this, 282) != null;
};


/**
 * optional bool is_bookmarked_by_user = 604;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getIsBookmarkedByUser =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 604, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setIsBookmarkedByUser =
    function(value) {
  return jspb.Message.setProto3BooleanField(this, 604, value);
};


/**
 * optional int64 steps_in_answer = 605;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getStepsInAnswer =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 605, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setStepsInAnswer = function(
    value) {
  return jspb.Message.setProto3IntField(this, 605, value);
};


/**
 * optional int64 current_step = 607;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getCurrentStep =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 607, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setCurrentStep = function(
    value) {
  return jspb.Message.setProto3IntField(this, 607, value);
};


/**
 * optional int64 steps_in_preview = 608;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getStepsInPreview =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 608, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setStepsInPreview =
    function(value) {
  return jspb.Message.setProto3IntField(this, 608, value);
};


/**
 * optional int64 blocks_in_preview = 609;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getBlocksInPreview =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 609, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setBlocksInPreview =
    function(value) {
  return jspb.Message.setProto3IntField(this, 609, value);
};


/**
 * optional bool preview_has_image = 610;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getPreviewHasImage =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 610, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setPreviewHasImage =
    function(value) {
  return jspb.Message.setProto3BooleanField(this, 610, value);
};


/**
 * optional bool preview_has_drawing = 612;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getPreviewHasDrawing =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 612, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setPreviewHasDrawing =
    function(value) {
  return jspb.Message.setProto3BooleanField(this, 612, value);
};


/**
 * optional bool preview_has_equation = 613;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getPreviewHasEquation =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 613, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setPreviewHasEquation =
    function(value) {
  return jspb.Message.setProto3BooleanField(this, 613, value);
};


/**
 * optional bool preview_has_table = 614;
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getPreviewHasTable =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 614, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setPreviewHasTable =
    function(value) {
  return jspb.Message.setProto3BooleanField(this, 614, value);
};


/**
 * optional int64 character_count_in_preview = 615;
 * @return {number}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getCharacterCountInPreview =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 615, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setCharacterCountInPreview =
    function(value) {
  return jspb.Message.setProto3IntField(this, 615, value);
};


/**
 * optional google.protobuf.Timestamp solution_published_time = 616;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getSolutionPublishedTime =
    function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 616));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setSolutionPublishedTime =
    function(value) {
  return jspb.Message.setWrapperField(this, 616, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearSolutionPublishedTime =
    function() {
  return this.setSolutionPublishedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.hasSolutionPublishedTime =
    function() {
  return jspb.Message.getField(this, 616) != null;
};


/**
 * optional string solution_language = 617;
 * @return {string}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getSolutionLanguage =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 617, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setSolutionLanguage =
    function(value) {
  return jspb.Message.setProto3StringField(this, 617, value);
};


/**
 * optional SolutionType solution_type = 618;
 * @return {!proto.com.chegg.rio.qna.SolutionType}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getSolutionType =
    function() {
  return /** @type {!proto.com.chegg.rio.qna.SolutionType} */ (
      jspb.Message.getFieldWithDefault(this, 618, 0));
};


/**
 * @param {!proto.com.chegg.rio.qna.SolutionType} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setSolutionType = function(
    value) {
  return jspb.Message.setProto3EnumField(this, 618, value);
};


/**
 * optional SolutionFormat solution_format = 619;
 * @return {!proto.com.chegg.rio.qna.SolutionFormat}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getSolutionFormat =
    function() {
  return /** @type {!proto.com.chegg.rio.qna.SolutionFormat} */ (
      jspb.Message.getFieldWithDefault(this, 619, 0));
};


/**
 * @param {!proto.com.chegg.rio.qna.SolutionFormat} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setSolutionFormat =
    function(value) {
  return jspb.Message.setProto3EnumField(this, 619, value);
};


/**
 * optional SolutionSource solution_source = 620;
 * @return {!proto.com.chegg.rio.qna.SolutionSource}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getSolutionSource =
    function() {
  return /** @type {!proto.com.chegg.rio.qna.SolutionSource} */ (
      jspb.Message.getFieldWithDefault(this, 620, 0));
};


/**
 * @param {!proto.com.chegg.rio.qna.SolutionSource} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setSolutionSource =
    function(value) {
  return jspb.Message.setProto3EnumField(this, 620, value);
};


/**
 * repeated string solution_uuid = 621;
 * @return {!Array<string>}
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.getSolutionUuidList =
    function() {
  return /** @type {!Array<string>} */ (
      jspb.Message.getRepeatedField(this, 621));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.setSolutionUuidList =
    function(value) {
  return jspb.Message.setField(this, 621, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.addSolutionUuid = function(
    value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 621, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.chegg.rio.qna.ComponentAEAnswer} returns this
 */
proto.com.chegg.rio.qna.ComponentAEAnswer.prototype.clearSolutionUuidList =
    function() {
  return this.setSolutionUuidList([]);
};


goog.object.extend(exports, proto.com.chegg.rio.qna);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/client/frontend/web/component_ae_answer_pb.js
// module id = 4268
// module chunks = 11